function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.471 10.3675V18.6325C25.471 19.9858 24.746 21.2425 23.574 21.9313L16.3965 26.0758C15.2244 26.7525 13.7744 26.7525 12.5902 26.0758L5.41271 21.9313C4.24062 21.2546 3.51562 19.9979 3.51562 18.6325V10.3675C3.51562 9.01417 4.24062 7.75745 5.41271 7.0687L12.5902 2.92413C13.7623 2.24746 15.2123 2.24746 16.3965 2.92413L23.574 7.0687C24.746 7.75745 25.471 9.00208 25.471 10.3675Z",
    stroke: "#3674CB",
    style: {
      stroke: "#3674CB",
      stroke: "color(display-p3 0.2118 0.4549 0.7961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.501 13.2917C16.0559 13.2917 17.3164 12.0312 17.3164 10.4763C17.3164 8.92134 16.0559 7.66089 14.501 7.66089C12.9461 7.66089 11.6855 8.92134 11.6855 10.4763C11.6855 12.0312 12.9461 13.2917 14.501 13.2917Z",
    stroke: "#3674CB",
    style: {
      stroke: "#3674CB",
      stroke: "color(display-p3 0.2118 0.4549 0.7961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3327 20.1308C19.3327 17.9558 17.1698 16.1917 14.4993 16.1917C11.8289 16.1917 9.66602 17.9558 9.66602 20.1308",
    stroke: "#3674CB",
    style: {
      stroke: "#3674CB",
      stroke: "color(display-p3 0.2118 0.4549 0.7961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOctagon);
export default __webpack_public_path__ + "static/media/user-octagon.b1f6930c342526e4450670d0823e8422.svg";
export { ForwardRef as ReactComponent };